import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    Containers,
} from 'app/Apps/ContainerManagement/Containers/containers.types'

const config: SkyNetTableConfig<keyof Containers> = {
    name: 'ContainerSelection.WrongPairings',
    tabs: [{
        name: 'Wrong Pairings',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'serialNumber',
                width: '130px',
            },
            {
                name: 'containerTypeContainerModel',
                width: '200px',
            },
            {
                name: 'currentOrderOrderNumber',
            },
            {
                name: 'lastMeasuredOnUtcInternal',
                componentName: 'Age',
                width: '150px',
                sorting: false,
            },
            {
                name: 'lastMeasuredOnUtcAmbient',
                componentName: 'Age',
                width: '150px',
                sorting: false,
            },
            {
                name: 'currentInternalLocationLocationName',
            },
            {
                name: 'currentAmbientLocationLocationName',
            },
        ],
    }],
}

export default config
